import React from 'react'
import Client from '../../models/client'
import { Box, Group, Text, ThemeIcon, Title } from '@mantine/core'
import { ChartLineIcon } from '@phosphor-icons/react'
import { FETCH_KEYS, fetchGuestExport } from '../api'
import { AnalysisListSearchForm } from '../components/AnalysisListSearchForm'
import { ColumnsSelector } from '../components/ColumnsSelector'
import { AnalysisListTable } from '../components/AnalysisListTable'
import { useAnalysisList } from '../hooks/useAnalysisList'

interface Props {
  client: Client
}

const GuestListContainer: React.FC<Props> = ({ client }) => {
  const {
    combinedRows,
    sliceOffset,
    totalCount,
    crmColumns,
    dbColumns,
    allColumns,
    filterableColumns,
    fetchError,
    isLoading,
    crmStorageKey,
    dbStorageKey,
    selectedCrm,
    setSelectedCrm,
    selectedDb,
    setSelectedDb,
    page,
    setPage,
    perPage,
    handleChangePerPage,
    sortState,
    handleChangeSort,
    columnFilters,
    handleChangeColumnFilters,
    handleSubmit,
    isExporting,
    csvError,
    handleExportCsv,
  } = useAnalysisList({
    client,
    storageKeyPrefix: 'guestList',
    fetchListKey: FETCH_KEYS.fetchGuestList,
    exporter: fetchGuestExport,
  })

  return (
    <Box>
      <Group gap={12} mb={16}>
        <ThemeIcon variant='transparent'>
          <ChartLineIcon weight='fill' size={36} />
        </ThemeIcon>
        <Title size={24} fw={600} c="#000000CC">ゲスト一覧</Title>
      </Group>

      <Text fz={14} c="#000000CC">
        invyで取得したゲストの詳細情報（訪問数、CV日時など）を分析できます。
      </Text>

      <AnalysisListSearchForm columns={allColumns} onSubmit={handleSubmit} disabled={isExporting} />
      {fetchError && <Text c="red">読み込みに失敗しました</Text>}

      <Group gap={24} mt={16}>
        <ColumnsSelector
          columns={crmColumns}
          selectedFields={selectedCrm}
          onChange={setSelectedCrm}
          storageKey={crmStorageKey}
          label='データ一覧'
        />
        {dbColumns.length > 0 && (
          <ColumnsSelector
            columns={dbColumns}
            selectedFields={selectedDb}
            onChange={setSelectedDb}
            storageKey={dbStorageKey}
            label='ゲスト情報'
            showBulkActions
          />
        )}
      </Group>

      <AnalysisListTable
        combinedRows={combinedRows}
        sliceOffset={sliceOffset}
        columns={filterableColumns}
        page={page}
        onChangePage={setPage}
        perPage={perPage}
        onChangePerPage={handleChangePerPage}
        totalCount={totalCount}
        sortState={sortState}
        onChangeSort={handleChangeSort}
        columnFilters={columnFilters}
        onChangeColumnFilters={handleChangeColumnFilters}
        onExportCsv={handleExportCsv}
        isExporting={isExporting}
        isLoading={isLoading}
        csvError={csvError}
      />
    </Box>
  )
}

export default GuestListContainer
